import * as customerTypes from '../types/Customer';
import {COMPLAINT_SEARCH_COMPLAINT_SUCCESS} from '../types/Complaint';
import {INITIAL_STATE} from './state/Customer';
import {PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE,PAGE_GO_TO_START_PAGE, PAGE_GO_TO_CREATE_COMPLAINT_PAGE} from '../types/Page';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case customerTypes.CUSTOMER_CHANGE_BUILDING_NUMBER:
        case customerTypes.CUSTOMER_CHANGE_CITY:
        case customerTypes.CUSTOMER_CHANGE_COUNTRY:
        case customerTypes.CUSTOMER_CHANGE_EMAIL:
        case customerTypes.CUSTOMER_CHANGE_FLAT_NUMBER:
        case customerTypes.CUSTOMER_CHANGE_NAME:
        case customerTypes.CUSTOMER_CHANGE_SURNAME:
        case customerTypes.CUSTOMER_CHANGE_PHONE:
        case customerTypes.CUSTOMER_CHANGE_PHONE_CODE:
        case customerTypes.CUSTOMER_CHANGE_POSTAL_CODE:
        case customerTypes.CUSTOMER_CHANGE_STREET:
        case customerTypes.CUSTOMER_CHANGE_TAX:
        case customerTypes.CUSTOMER_CHANGE_COMPANY_NAME:
            return Object.assign(
                {}, 
                state, 
                action.payload
            );
        case customerTypes.CUSTOMER_CHANGE_TYPE:
            return {
                ...state,
                type: action.payload,
                companyTax: "",
                companyName: "",
                newCustomer: false,
            };
        case customerTypes.CUSTOMER_INIT_BY_COMPANY:
            return {
                ...state,
                buildingNumber: action.payload.buildingNumber,
                city: action.payload.city,
                id: action.payload.id,
                companyName: action.payload.companyName,
                companyTax: action.payload.companyTax,
                country: action.payload.country,
                flatNumber: action.payload.flatNumber,
                postalCode: action.payload.postalCode,
                street: action.payload.street,
                email: action.payload.email,
                newCustomer: false,
            };
        case customerTypes.CUSTOMER_INIT_BY_COMPANY_FOR_PURCHASE_ADDRESS:
            return {
                ...state,
                id: action.payload.id,
                companyName: action.payload.companyName,
                newCustomer: false,
            };
        case customerTypes.CUSTOMER_CHANGE_NEW_CUSTOMER:
            return{
                ...state,
                newCustomer: !state.newCustomer
            };
        case customerTypes.CUSTOMER_CHANGE_TYPE_TO_COMPANY: 
            return {
                ...state,
                type: {
                    ...state.type,
                    value: 'Company'
                }
            };
        case customerTypes.CUSTOMER_CHANGE_TYPE_TO_CORPORATE_ENTITY: 
            return {
                ...state,
                type: {
                    ...state.type,
                    value: 'CorporateEntity'
                }
            };
        case COMPLAINT_SEARCH_COMPLAINT_SUCCESS:
            return action.payload.customer;
        case PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case PAGE_GO_TO_START_PAGE: 
        case PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
            return INITIAL_STATE;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/Customer.js